// Cabeçalho comum das telas de dispositivo (/recepcao e /sala): marca, unidade, nome do link
// e indicador de conexão. O conteúdo fica em `.device-main`.
import type { ReactNode } from "react";
import { Wifi, WifiOff } from "lucide-react";
import { Brand } from "@centro-cirurgico/ui";

import { useOnline } from "../hooks/useOnline";

export interface DeviceShellProps {
  tag: string;
  title: string;
  subtitle?: string | undefined;
  /** Conteúdo extra à direita (badge de estado, botões). */
  actions?: ReactNode;
  children: ReactNode;
}

export function DeviceShell({ tag, title, subtitle, actions, children }: DeviceShellProps) {
  const online = useOnline();
  return (
    <div className="device-page">
      <header className="device-header">
        <div className="device-header-row">
          <Brand tag={tag} href={window.location.pathname} />
          <div className="device-context">
            <strong>{title}</strong>
            {subtitle && <small>{subtitle}</small>}
          </div>
          <div className="device-header-actions">
            {actions}
            <span className={`status-pill ${online ? "ok" : "danger"}`} role="status">
              {online ? <Wifi aria-hidden="true" size={16} /> : <WifiOff aria-hidden="true" size={16} />}
              {online ? "Conectado" : "Sem conexão"}
            </span>
          </div>
        </div>
      </header>
      <main className="device-main">{children}</main>
    </div>
  );
}
